// Human-readable descriptions of a voucher's life story, shared by the admin
// vouchers list and the order details voucher section so both read the same.

export interface VoucherLabelSource {
  reason: string
  initiator: string | null
  issued_by: string | null
  source_meal_disposal_reason?: string | null
}

const REASON_LABELS: Record<string, string> = {
  meal_failed: 'Meal could not be prepared',
  order_canceled: 'Order canceled',
  manual: 'Granted manually'
}

const CANCELATION_LABELS: Record<string, string> = {
  customer: 'Canceled by the customer',
  staff: 'Canceled by staff',
  system: 'Canceled by the kitchen'
}

export const voucherReasonLabel = (voucher: VoucherLabelSource): string => {
  if (voucher.reason === 'order_canceled' && voucher.initiator) {
    return CANCELATION_LABELS[voucher.initiator] || REASON_LABELS.order_canceled
  }

  return REASON_LABELS[voucher.reason] || voucher.reason
}

// The extra line under the reason: who exactly acted, or what the robot hit.
export const voucherReasonDetail = (voucher: VoucherLabelSource): string | null => {
  if (voucher.reason === 'meal_failed' && voucher.source_meal_disposal_reason) {
    return voucher.source_meal_disposal_reason.replaceAll('_', ' ')
  }
  if (voucher.initiator === 'staff' && voucher.issued_by) return voucher.issued_by

  return null
}

export const invalidatedReasonLabel = (reason: string | null): string => {
  if (reason === 'customer_refund') return 'customer took a refund instead'
  if (reason === 'admin') return 'invalidated by staff'

  return 'reason not recorded'
}
